import { z } from "zod";
import { EMAIL_INVALID_MESSAGE } from "../validation-messages";

export const forgotPasswordSchema = z
  .object({
    email: z.string().email({ message: EMAIL_INVALID_MESSAGE }).min(1, "Email is required"),
    redirectHref: z.string().url(),
    ReCAPTCHA: z.string().optional(),
    courseProviderId: z.string().optional(),
    color1: z.string().optional(),
  })
  .refine(
    (data) => {
      if (process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY && !data.ReCAPTCHA) {
        return false;
      }
      return true;
    },
    {
      message: "ReCAPTCHA is required",
      path: ["ReCAPTCHA"],
    }
  );

export type ForgotPasswordSchemaType = z.infer<typeof forgotPasswordSchema>;
